import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { reduxForm } from 'redux-form';
import { formSettings } from './../settings';
import { FormattedMessage, FormattedHTMLMessage } from 'react-intl';
import messages from '../../../../../../text/messages';
import Table from './../../../../../../components/table';
import { getAddress, getFullName } from './../../../../../../utilities/string';
import WizardButtons from '../../../../../../components/wizard/navigator/buttons';
import { getPosition, completeOnboarding } from '../../../../../../reducers/onboarding';
import { executeJobAction } from '../../../../../../reducers/jobs';
import { getRequirements } from '../../../../../../reducers/tenants';
import { history } from '../../../../../../configuration/store';
import { submitOnboarding } from '../../../../../../reducers/identity';
import { approveJob } from '../../../../../../reducers/approvals';

import { dateToFloatingString } from '../../../../../../utilities/dateTime';
import mixpanel from 'mixpanel-browser';
class ContractorNextStepsStep extends React.Component {
    constructor(props) {
        super(props);

        this.getTableData = this.getTableData.bind(this);
        this.submit = this.submit.bind(this);
    }

    componentDidMount() {
        mixpanel.track('WorkerOnboarding', { _data: { branch: 'ic', step: 'ContractorNextStepsStep' } });

        const { job, position, getPosition } = this.props;
        if (!position) {
            getPosition(job.position_id);
        }
    }

    submit() {
        const { role, job, details, executeJobAction, getRequirements, submitOnboarding, completeOnboarding, approveJob } = this.props;
        executeJobAction(job.id, 'submit', () => {
            submitOnboarding(details, role, () => {
                approveJob(job, () => {
                    getRequirements(role, () => {
                        completeOnboarding(() => history.push('/'));
                    });
                });
            });
        });
    }

    getTableData() {
        const { job, position } = this.props;

        let workLocation =
            position.work_location_type === 'offsite' ? (
                <FormattedMessage {...messages.workLocationAtYourLocation} />
            ) : (
                getAddress(position.work_location_address)
            );

        return {
            columns: [
                { valueMap: d => <span className="row-label">{d.label}</span>, size: 'col-xs-12 col-md-3' },
                { valueMap: d => <span className="row-value">{d.value}</span>, size: 'col-xs-12 col-md-9' }
            ],
            data: [
                { label: <FormattedMessage {...messages.startDate} />, value: dateToFloatingString(job.start_date) },
                { label: <FormattedMessage {...messages.workLocation} />, value: workLocation },
                { label: <FormattedMessage {...messages.pointOfContact} />, value: getFullName(position.hiring_manager) }
            ]
        };
    }

    render() {
        const { handleSubmit, onSubmit, back, submitting, position } = this.props;
        if (!position) {
            return null;
        }

        let tableData = this.getTableData();

        return (
            <form onSubmit={handleSubmit(values => this.submit(values, onSubmit))}>
                <div className="row section">
                    <div className="col-xs-12">
                        <FormattedMessage {...messages.onboardingICCongrats} />
                    </div>
                </div>
                <div className="row section">
                    <div className="col-xs-12">
                        <FormattedHTMLMessage
                            id={'icFinishDetails'}
                            tagName={'p'}
                            defaultMessage={`We've let your manager know that you are approved to start.<br /><br />If you have any questions for us, you can always reach us at <a href="mailto:hr@greenlight.ai">hr@greenlight.ai</a>.`}
                        />
                    </div>
                </div>
                <div className="row section">
                    <div className="col-xs-12">
                        <Table {...tableData} rowStyle={'onboarding-table-row'} />
                    </div>
                </div>

                <WizardButtons disabled={submitting} back={{ action: back }} submit={{ message: <FormattedMessage {...messages.complete} /> }} />
            </form>
        );
    }
}

ContractorNextStepsStep = reduxForm(formSettings)(ContractorNextStepsStep);

const mapStateToProps = state => {
    return {
        role: state.identity.role,
        job: state.onboarding.job,
        details: state.identity.details,
        position: state.onboarding.position
    };
};

const mapDispatchToProps = dispatch =>
    bindActionCreators(
        {
            getPosition: getPosition,
            executeJobAction: executeJobAction,
            getRequirements: getRequirements,
            submitOnboarding: submitOnboarding,
            completeOnboarding: completeOnboarding,
            approveJob: approveJob
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(ContractorNextStepsStep);



// WEBPACK FOOTER //
// ./src/pages/onboarding/tenants/contractor/steps/contractor/contractorNextSteps.jsx